import { render } from "./OptionsList.vue?vue&type=template&id=220fd822&scoped=true"
import script from "./OptionsList.vue?vue&type=script&lang=js"
export * from "./OptionsList.vue?vue&type=script&lang=js"

import "./OptionsList.vue?vue&type=style&index=0&id=220fd822&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220fd822"]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QCircularProgress,QBtn});
